import { useCluster } from '@cast/shared-cluster-context-data-access';
import { usePaginatedWorkloadCostSummariesQuery } from '@cast/split-me/hooks';

import { useComputeAdjustedDateRange } from './useComputeAdjustedDateRange';

const PAGE_LIMIT = 50;

export const useInventoryComputeCostSummaries = () => {
  const { cluster } = useCluster();
  const { adjustedDateRange } = useComputeAdjustedDateRange();

  const [from, to] = adjustedDateRange;

  const {
    workloads,
    count,
    noDataReason,
    isLoading,
    error,
    refetch,
    hasNextPage,
    fetchNextPage,
    isFetching,
  } = usePaginatedWorkloadCostSummariesQuery({
    clusterId: cluster.id,
    startTime: from.toISOString(),
    endTime: to.toISOString(),
    useListingPrices: false,
    includeIdleCosts: false,
    pageLimit: PAGE_LIMIT,
    sortBy: 'totalCost',
    sortDirection: 'desc',
  });

  return {
    workloads,
    count,
    noDataReason,
    isLoading,
    error,
    refetch,
    hasNextPage,
    fetchNextPage,
    isFetching,
  };
};
